export async function makeRequest({
  url,
  method = "GET",
  body,
  alertOnFailure = true
}) {
  const request = {
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "X-CSRF-Token": document.querySelector("meta[name=csrf-token]")?.content
    },
    method: method,
    body: JSON.stringify(body)
  }

  if (method === "GET") {
    delete request[body]
  }

  const response = await fetch(url, request)
  let data

  if (response.status.toString()[0] === "2") {
    data = await response.json()
  } else {
    if (alertOnFailure) {
      alert("Something went wrong. Please reload this page and try again.")
    }
    data = null
  }

  return data
}
